import { Eye } from 'lucide-react';
import { t } from '@/lib/i18n';

/** Shown to operators on pages only administrators may change. */
export function ReadOnlyNotice() {
  return (
    <div className="mb-4 flex items-center gap-2 rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-900 ring-1 ring-amber-200">
      <Eye className="size-4 shrink-0" />
      {t('View only: only administrators can change this.')}
    </div>
  );
}
